import { PlatformComponent } from "./Model.model";

export class Workflow {
  bpmnXml: string;
  workflowId: number;
  name: string;
  description: string;
  refineryName: string;
  createdBy: string;
  lastUpdatedTimeStamp: Date;
  lastUpdatedBy: string;

  initialComponentUniqueIds: string[];
  component: PlatformComponent[];

  constructor() {
    this.bpmnXml = '';
    this.workflowId = 0;
    this.name = '';
    this.description = '';
    this.refineryName = 'Donges';
    this.createdBy = '';
    this.lastUpdatedTimeStamp = new Date();
    this.lastUpdatedBy = '';

    this.initialComponentUniqueIds = [];
    this.component = [];
  }
}

export enum DataSrc {
  component = 0,
  user = 1,
  extDataSrc = 2
}
